import { Box, Button, Flex, Text } from '@driftt/dds'
import React from 'react'

import { configByType } from './constants'

export const Validation = ({
  prompt = '',
  response = '',
  type,
  onUse,
  responseDate,
  isModeration,
}: {
  prompt: string
  response?: string
  type?: keyof typeof configByType
  onUse?: () => void
  divider?: boolean
  responseDate: string
  isModeration?: boolean
}) => (
  <Flex direction="column" gap={2}>
    {type && configByType[type]?.validationTitle ? (
      <Text variant="bodyBold">{configByType[type].validationTitle}</Text>
    ) : null}
    <Flex
      css={{
        paddingLeft: '$3',
      }}
    >
      <Box
        css={{
          backgroundColor: '$gray2',
          borderRadius: '6px',
          padding: '$1',
        }}
      >
        {prompt}
      </Box>
    </Flex>
    <Text>{response}</Text>
    <Flex direction="column">
      {!!onUse && (type || isModeration) && (
        <Button onClick={onUse} variant="primary">
          {type ? configByType[type].buttonText : 'Use this response'}
        </Button>
      )}
      <Text variant="metadata" css={{ color: '$gray7' }}>
        {responseDate}
      </Text>
    </Flex>
  </Flex>
)
